<div class="infinite-scroll" appInfiniteScroll [distance]="2" [throttle]="50" [lockBottom]="true" [lockBeforeReset]="true" (onScroll)="onScroll()">
  <h2 #h2>
    <span>Notifications</span>
    <i class="material-icons" [matMenuTriggerFor]="menu">more_horiz</i>
  </h2>

  @for (notification of notifications; track trackByFn($index, notification)) {
    <div class="notification" (click)="open(notification)">
      <h3>{{notification.title}}</h3>
      <p class="body">{{notification.body}}</p>
      <p class="ago" [ngClass]="{'not-opened': notification.clickStatus === 'READ'}">{{notification.ago}}</p>
    </div>
  }

  @if (hasError) {
    <div class="error-section">
      <i class="material-icons">notifications_off</i>
      <p>Sorry we couldn't load any notifications. Please try to refresh!</p>
    </div>
  }
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item style="display: flex !important;" (click)="markAllRead()" [disabled]="hasError || !notifications.length">
    <i class="material-icons mr-2.5">check</i>
    Mark all as read
  </button>
  <button mat-menu-item style="display: flex !important;" (click)="getNotifications(true)">
    <i class="material-icons mr-2.5">
      refresh
    </i>
    Refresh Notifications
  </button>
</mat-menu>
